export default "__VITE_PUBLIC_ASSET__e8aa9084__"